import { render, staticRenderFns } from "./SmartCamV3.vue?vue&type=template&id=0c3a13f8&scoped=true&"
import script from "./SmartCamV3.vue?vue&type=script&lang=js&"
export * from "./SmartCamV3.vue?vue&type=script&lang=js&"
import style0 from "./SmartCamV3.vue?vue&type=style&index=0&id=0c3a13f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a13f8",
  null
  
)

export default component.exports